
import { RemindersKeys } from '@/i18n/types/reminders.types';

export const reminders: Record<RemindersKeys, string> = {
  reminders: 'Reminders',
  reminder: 'Reminder',
  reminderTitle: 'Title',
  reminderDescription: 'Description',
  createReminder: 'Create Reminder',
  editReminder: 'Edit Reminder',
  deleteReminder: 'Delete Reminder',
  cancelReminder: 'Cancel Reminder',
  snoozeReminder: 'Snooze Reminder',
  reminderDateTime: 'Date and Time',
  reminderRecurrence: 'Recurrence',
  reminderTimezone: 'Timezone',
  reminderChannels: 'By Location',
  reminderSnoozeInterval: 'Snooze Interval',
  reminderStatus: 'Status',
  reminderStatusPending: 'Pending',
  reminderStatusSent: 'Sent',
  reminderStatusSnoozed: 'Snoozed',
  reminderStatusCancelled: 'Cancelled',
  reminderSearch: 'Search reminders',
  reminderNoResults: 'No reminders found',
  reminderLoading: 'Loading reminders...',
  reminderNotifications: 'Notifications',
  reminderManagement: 'Never forget the important things with smart and personalized reminders.',
  reminderCustomPatterns: 'Set recurring patterns',
  reminderCustomPatterns1: 'Notifications',
  reminderMultipleChannels: 'Multiple channels',
  reminderToday: 'Today',
  reminderWeek: 'Next 7 days',
  reminderAll: 'All',
  reminderSave: 'Save',
  reminderCancel: 'Cancel',
  reminderCreated: 'Reminder created successfully',
  reminderUpdated: 'Reminder updated successfully',
  reminderDeleted: 'Reminder deleted successfully',
  reminderSnoozeFor: 'Snooze for',
  reminderMinutes: 'minutes',
  addReminder: 'New Reminder',
  filterByStatus: 'Filter by status',
  allStatuses: 'All statuses',
  searchReminders: 'Search reminders...',
  noReminders: 'No reminders',
  noRemindersDesc: 'No reminders found for the current filters.',
  loadingReminders: 'Loading reminders...',
  confirmDeleteReminder: 'Are you sure you want to delete this reminder?',
};
